<template>
<div class="tw-text-sm font-normal">
  <a class="tw-link" :target="storeAnswer.data.value ? '_blank' : undefined" :href="(storeAnswer.data.value||'').includes('//') ? storeAnswer.data.value : '//'+(storeAnswer.data.value||'')">
    {{ storeAnswer.data.value }}
  </a>
</div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>